import { useQuery } from '@tanstack/react-query';
import { fetchCompanySettings } from '../../lib/services/companyService';
import { CompanySettings } from '../../lib/types/company';

/**
 * Custom hook to fetch company settings using React Query.
 * @returns The query result containing company settings data, loading state, and error state.
 */
type Options = { enabled?: boolean };

export function useCompanySettingsInfo(opts: Options = {}) {
  return useQuery<CompanySettings>({
    queryKey: ['companySettings'],
    queryFn: fetchCompanySettings,
    staleTime: 30 * 60 * 1000, // 30 minutes
    enabled: opts.enabled ?? true,
  });
}

/**
 * Metadata for the useCompanySettingsInfo hook.
 */
export const useCompanySettingsInfoMeta = {
  key: 'companySettings',
  url: '/company/settings',
  method: 'GET',
  params: [],
};
